import {createContext, useContext, useEffect, useState} from "react";
import {today, dateStrToDateObj} from "../shared/date.js";
import { useAuth } from "./Auth/AuthPage.jsx";
export const DanceEventContext = createContext({events: []});

export const DanceEventProvider = (props) => {

    const [events, setEvents] = useState([]);
    const [myCreatedEventMap, setMyCreatedEventMap] = useState({});
    const [myCreatedEvents, setMyCreatedEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [startDate, setStartDate] = useState(today());
    const {user} = useAuth()

    setInterval(() => setStartDate(today()), 1000 * 60 * 5); // Update startDate every 5 minutes

    const loadMyCreatedEvents = async (callback) => {
        const token = window.localStorage.getItem("authToken");
        if (!token) {
            setMyCreatedEventMap({});
            setMyCreatedEvents([]);
            if (typeof callback === "function") setTimeout(() => callback.call(), 100);
            return;
        }
        let allEvents = [];
        let page = 1;
        const pageSize = 100;
        let totalPages = 1;

        

        // Calculate date range: today to six weeks from today
        const t = dateStrToDateObj(startDate);
        const sixWeeks = dateStrToDateObj(startDate);
        sixWeeks.setDate(sixWeeks.getDate() + 42);
        const formatDate = d => d.toISOString().slice(0, 10);

        const fromDate = formatDate(t);
        const toDate = formatDate(sixWeeks);

        try {
            do {
                const res = await fetch(
                    `${process.env.REACT_APP_BACKEND_HOST}/events/mine?pagination[page]=${page}&pagination[pageSize]=${pageSize}&sort[0]=date:asc&filters[date][$gt]=${fromDate}&filters[date][$lte]=${toDate}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                const data = await res.json();
                if (data) {
                    allEvents = allEvents.concat(data);
                }
                // Get total pages from meta if available
                totalPages = data.meta?.pagination?.pageCount || 1;
                page++;
            } while (page <= totalPages);
            setMyCreatedEvents(allEvents);
            const myEventMap = allEvents.reduce((acc, event) => {
                acc[event.documentId] = event
                return acc;
            }, {})
            setMyCreatedEventMap(myEventMap);
        } catch (e) {
            setMyCreatedEvents([]);
            setMyCreatedEventMap({});
        }
      
        if (typeof callback === "function") setTimeout(() => callback.call(), 100);
    };

    const loadEvents = async (callback) => {
        setLoading(true);

        // Calculate date range: today to six weeks from today
        const sixWeeks = dateStrToDateObj(startDate);
        sixWeeks.setDate(sixWeeks.getDate() + 42);

        try {
            const res = await fetch(
                `${process.env.REACT_APP_BACKEND_HOST}/events/calendar`
            );
            let allEvents = await res.json();

            // Filter out events before startDate
            const startDateObj = dateStrToDateObj(startDate);
            allEvents = allEvents.filter(event => {
                const eventDate = dateStrToDateObj(event.date);
                return eventDate >= startDateObj;
            });

            // --- Filter logic ---
            // Only apply filter if NOT calendarAdmin
            const isCalendarAdmin = user && user.calendarAdmin === true;
            if (!isCalendarAdmin) {
                allEvents = allEvents
                    .map(event => {
                        // Remove event_instructors and event_artists with listing 'hidden' or 'deleted'
                        const filteredInstructors = Array.isArray(event.event_instructors)
                            ? event.event_instructors.filter(i => i.listing !== 'hidden' && i.listing !== 'deleted')
                            : [];
                        const filteredArtists = Array.isArray(event.event_artists)
                            ? event.event_artists.filter(a => a.listing !== 'hidden' && a.listing !== 'deleted')
                            : [];
                        return {
                            ...event,
                            event_instructors: filteredInstructors,
                            event_artists: filteredArtists
                        };
                    })
                    .filter(event =>
                        (event.event_instructors && event.event_instructors.length > 0) ||
                        (event.event_artists && event.event_artists.length > 0)
                    );
            }
            // ---

            setEvents(allEvents);
        } catch (e) {
            setEvents([]);
        }
        setLoading(false);
        if (typeof callback === "function") setTimeout(() => callback.call(), 100);
    };

    useEffect(() => {
        loadEvents();

        //ensure a refresh every hour
        const i1 = setInterval(loadEvents, 300 * 1000);

        return () => {
            clearInterval(i1);
        }
    }, []);

    useEffect(() => {
        if (user) {
            loadMyCreatedEvents();
        }

        
    }, [user]);

    return <DanceEventContext.Provider value={{
            events: events,
            loading: loading,
            myCreatedEventMap: myCreatedEventMap,
            myCreatedEvents: myCreatedEvents,
            loadEvents: loadEvents
        }}>
        {props.children}
    </DanceEventContext.Provider>


}

export const useEvents = () => {
    const context = useContext(DanceEventContext);
    if (!context) {
        throw new Error('useEvents must be used within an DanceEventContext.Provider');
    }

    return context;
};
